/* eslint-disable max-lines */
// EN + NL dictionaries for the remaining static pages and shared components.
// Imported by I18nContext.jsx.

export const staticEn = {
  about: {
    seo_title: "About 5999Cargo — Cargo with a smile since 2014",
    seo_description:
      "Meet 5999Cargo Group Europe — a family-owned freight forwarder shipping from Rotterdam to Curaçao, Aruba, Bonaire and the Caribbean since 2014. Multilingual team, end-to-end service.",
    seo_keywords: "about 5999Cargo, freight forwarder Rotterdam Caribbean, Dutch logistics company, family-owned forwarder",
    eyebrow: "/ About Us",
    h1_a: "We connect Holland to the islands —",
    h1_b: "one shipment at a time.",
    story_eyebrow: "/ Our story",
    story_title_a: "Rooted in Rotterdam.",
    story_title_b: "Connected to Curaçao.",
    story_p1:
      "5999Cargo Group Europe was founded in 2014 by a Dutch-Curaçaoan family who were tired of seeing friends and relatives pay too much for slow, unreliable shipping between the two countries.",
    story_p2:
      "What started as a single shared container leaving Rotterdam every two weeks has grown into a full-service freight forwarder handling 1,200+ shipments per year — air, sea, household relocations and Shop-Drop-Ship for hundreds of small businesses serving the Caribbean.",
    story_p3:
      "We're still based in our original warehouse on Steenhouwerstraat. Still family-owned. Still on first-name basis with our customers — most of whom started with one box and now ship monthly.",
    stats: [
      { v: "12", l: "Years experience" },
      { v: "1,200+", l: "Yearly shipments" },
      { v: "8", l: "Caribbean destinations" },
      { v: "98%", l: "On-time delivery" },
    ],
    values_eyebrow: "/ Our values",
    values_title: "What you get when you ship with us",
    values: [
      { title: "Rotterdam roots", desc: "Family-owned business operating from Steenhouwerstraat since 2014." },
      { title: "Caribbean focus", desc: "We don't ship everywhere — we ship to Curaçao, Aruba, Bonaire and surrounding islands. We know the routes inside-out." },
      { title: "Multilingual team", desc: "Dutch, English, Papiamento, Spanish. We speak the language of both sides of the Atlantic." },
      { title: "Compliant & insured", desc: "Fully licensed freight forwarder, registered with the Dutch Chamber of Commerce." },
    ],
  },

  contact: {
    seo_title: "Contact 5999Cargo Netherlands — Quote & Customer Service",
    seo_description:
      "Contact 5999Cargo Netherlands for parcels, air freight, sea freight, pickup, tracking and quote requests. WhatsApp, email or phone — response within 1 business hour.",
    seo_keywords: "contact 5999Cargo, shipping Rotterdam contact, freight Curaçao quote, customer service cargo",
    eyebrow: "/ Contact",
    h1_a: "Talk to a real human.",
    h1_b: "Within 1 hour.",
    intro:
      "WhatsApp is the fastest way to reach us. Or send a message — we reply within one business hour during NL working hours (Mon–Fri 09:00–18:00 CET).",
    card_whatsapp_label: "WhatsApp (fastest)",
    card_email_label: "Email",
    card_phone_label: "Phone",
    card_hours_label: "Hours",
    card_hours_value_line1: "Mon–Fri 09–18",
    card_hours_value_line2: "Sat 10–14",
    card_hours_value_zone: "(CET)",
    tab_quote: "Get a quote",
    tab_message: "Send a message",
    msg_title: "Send a message",
    msg_name: "Name",
    msg_email: "Email",
    msg_phone: "Phone",
    msg_subject: "Subject",
    msg_message: "Message",
    msg_submit: "Send message →",
    msg_sending: "Sending...",
    msg_required_error: "Please fill in all required fields.",
    msg_send_success: "Message sent! We'll reply within 1 business hour.",
    msg_send_error: "Could not send. Please try WhatsApp.",
    visit_title: "Visit us",
    company_name: "5999Cargo Group Europe",
    dropoff_title: "Drop-off welcome",
    dropoff_desc:
      "Drop your boxes at our warehouse Mon–Fri 09:00–17:00. Free parking on-site. Just bring the recipient address and we'll handle the rest.",
  },

  webshop: {
    seo_title: "Webshop — Shipping Boxes, Pickup & Payment Links | 5999Cargo",
    seo_description:
      "Order shipping boxes, book pickups in the Netherlands, and pay for active shipments. Secure Stripe checkout.",
    seo_keywords: "shipping boxes Netherlands, book pickup Rotterdam, pay shipment online, Stripe checkout cargo",
    eyebrow: "/ Webshop",
    h1: "Boxes, pickups & payments.",
    sub:
      "Everything you need to send your package — from heavy-duty boxes to scheduled pickup and secure online payment for active shipments.",
    filter_all: "All",
    filter_boxes: "Shipping Boxes",
    filter_services: "Pickup Services",
    filter_payment: "Pay a Shipment",
    add_to_cart: "Add to cart",
    added_toast: "added to cart",
    cart_empty: "Your cart is empty. Add boxes or services to get started.",
    cart_title: "Your cart",
    cart_subtotal: "Subtotal",
    cart_vat_note: "VAT calculated at checkout.",
    checkout_email_placeholder: "Email for receipt",
    checkout_name_placeholder: "Full name (optional)",
    checkout_button: "Checkout securely →",
    checkout_redirecting: "Redirecting...",
    checkout_powered_by: "Powered by Stripe",
    checkout_email_required: "Please enter your email for the order receipt.",
    cart_empty_error: "Cart is empty.",
    checkout_error: "Could not start checkout. Please try again.",
    cta_quote_title: "Need a quote instead of buying boxes?",
    cta_quote_sub: "If you have a complex shipment, we'll quote it manually within 1 business hour.",
    cta_quote_label: "Request quote",
  },

  payment: {
    seo_title: "Payment Status | 5999Cargo",
    seo_description: "Your payment status with 5999Cargo.",
    checking_title: "Confirming your payment...",
    checking_sub: "This usually takes a few seconds.",
    paid_title: "Payment received. Thank you!",
    paid_sub:
      "We've emailed your receipt. Our team will be in touch shortly with next steps for your shipment.",
    back_home: "Back to home",
    continue_shopping: "Continue shopping",
    expired_title: "Payment session expired",
    error_title: "Could not confirm payment",
    missing_sub: "No payment session found in the URL.",
    error_sub:
      "If you completed payment, you'll receive an email confirmation. Please contact us if you have any concerns.",
    back_webshop: "Back to webshop",
    contact_us: "Contact us",
  },

  blog: {
    list_seo_title: "Shipping & Logistics Blog — Curaçao, Caribbean & Netherlands | 5999Cargo",
    list_seo_description:
      "Guides, costs, and tips for shipping packages, freight and household moves between the Netherlands and the Caribbean.",
    list_seo_keywords: "shipping blog, Curaçao shipping guide, freight tips Netherlands, moving Caribbean blog",
    eyebrow: "/ Blog",
    h1: "Shipping & logistics insights.",
    sub:
      "Guides, real cost breakdowns, and customs tips — written by the team that ships to the Caribbean every week.",
    read_article: "Read article",
    not_found: "Article not found",
    back_to_blog: "Back to blog",
    all_articles: "All articles",
    cta_title: "Ready to ship?",
    cta_sub: "Get a quote in under 60 seconds — or chat with us on WhatsApp.",
  },

  not_found: {
    eyebrow: "/ 404",
    h1: "Page not found",
    desc: "The page you're looking for doesn't exist or has been moved.",
    back_home: "Back to home",
  },

  testimonials_data: [
    {
      name: "Maria S.",
      role: "Relocated Rotterdam → Willemstad",
      text: "5999Cargo handled our complete move with care. Boxes arrived intact in 14 days, exactly as quoted. The pickup team in Rotterdam was on time and professional.",
    },
    {
      name: "Kevin D.",
      role: "E-commerce seller",
      text: "I ship 30+ orders per week to Curaçao. Their Shop, Drop & Ship cuts my fulfillment costs by half versus PostNL. Tracking is reliable and customs clearance is fast.",
    },
    {
      name: "Anouk P.",
      role: "Sending packages to family",
      text: "Sent a 50kg box to my mother in Otrobanda. Picked up from my flat in Den Haag, delivered to her door 11 days later. Communication via WhatsApp was excellent.",
    },
  ],

  process_eyebrow: "/ Process",

  hubs: {
    seo_title: "Hubs & Locations | 5999Cargo Group Europe",
    seo_description:
      "12 strategic hubs across Europe, the Caribbean and the Americas — Rotterdam, Curaçao, Miami, Aruba, Bonaire, St. Maarten, Suriname, Dominican Republic, Venezuela, Colombia, Jamaica, Guyana.",
    seo_keywords:
      "5999Cargo hubs, freight locations Caribbean, Rotterdam Curaçao Miami offices, international cargo network",
    eyebrow: "/ Hubs & Locations",
    h1: "One network. Twelve hubs. Door-to-door cargo.",
    intro:
      "We operate our own physical hubs across Europe, the Caribbean and the Americas — so your cargo is handled by our team from pickup to final delivery. Reach the hub nearest to you.",
    featured_title: "Main hubs",
    other_title: "Regional hubs",
    contact_hub: "Contact this hub",
    note_title: "Important operational note",
    note_body:
      "Each local hub may apply its own procedures, opening hours, import rules, handling fees and destination charges. For shipments departing from the Netherlands, 5999Cargo Group Europe handles the Dutch intake, registration, document control and export processing. For local delivery, import duties or destination charges, please contact the relevant local hub directly.",
    cta_title: "Ready to ship? Reach the right hub instantly.",
    cta_sub: "Tell us origin + destination and we'll connect you to the hub handling your route.",
    cta_primary: "Request a quote",
  },

  home_faq: {
    title: "Frequently asked questions about shipping to Curaçao and the Caribbean",
    items: [
      {
        q: "Can I send a package to Curaçao via 5999Cargo?",
        a: "Yes. You can ship packages, boxes, suitcases, pallets, vehicles and personal goods through 5999Cargo from the Netherlands to Curaçao. Depending on speed, volume and type of goods, we recommend air or sea freight.",
      },
      {
        q: "Which is cheaper: air freight or sea freight?",
        a: "Sea freight is usually more affordable for larger volumes — boxes, pallets, furniture and full moves. Air freight is faster and suitable for smaller or urgent shipments.",
      },
      {
        q: "Can 5999Cargo collect my shipment?",
        a: "Yes. With our Pickup & Delivery service we collect from your home, office, storage location or supplier. Costs depend on location, volume and time required.",
      },
      {
        q: "Which documents do I need?",
        a: "International shipments usually require an invoice, proof of purchase or packing list. The contents must be described clearly and completely. Without correct documents, processing may be delayed.",
      },
      {
        q: "Can I order online and have it delivered to 5999Cargo?",
        a: "Yes. With Shop, Drop & Ship you can order online and have your package delivered to 5999Cargo. We register your parcel and forward it after processing and payment to your chosen destination.",
      },
      {
        q: "Do you also ship for businesses?",
        a: "Yes. 5999Cargo supports businesses with air freight, sea freight, pallets, stock, webshop orders, supplier shipments and recurring cargo to the Caribbean.",
      },
      {
        q: "Are local import duties included?",
        a: "No. Local import duties, taxes and destination handling fees are usually not included unless agreed otherwise in writing. These costs are determined by local authorities or local handling.",
      },
      {
        q: "Can I also ship to other destinations?",
        a: "Yes. Besides Curaçao, 5999Cargo handles shipments to Aruba, Bonaire, Sint Maarten, Suriname, Miami, Colombia, Venezuela, Dominican Republic, Jamaica, Guyana and other destinations within our network.",
      },
    ],
  },

  banners: [
    {
      title: "From the Netherlands to Curaçao without the hassle",
      sub: "Packages, boxes, pallets and full moves via 5999Cargo. Request your quote now.",
      cta: "Request a quote",
      href: "/contact?get-quote=1",
    },
    {
      title: "Ordered online? Let 5999Cargo deliver it",
      sub: "Use our Shop, Drop & Ship service and forward your webshop orders to Curaçao and the Caribbean.",
      cta: "Discover Shop-Drop-Ship",
      href: "/shop-drop-ship",
    },
    {
      title: "Business cargo to the Caribbean",
      sub: "For entrepreneurs, webshops and suppliers who want to ship reliably to Curaçao, Bonaire, Aruba, Sint Maarten and Suriname.",
      cta: "Talk to a specialist",
      href: "/contact",
    },
    {
      title: "Larger shipment? Choose sea freight",
      sub: "Affordable shipping per box, pallet or m³. Ideal for moves, stock and trade goods.",
      cta: "Sea freight options",
      href: "/sea-freight",
    },
  ],

  contact_hubs: {
    eyebrow: "/ Our hub network",
    title: "International coverage you can trust",
    sub:
      "5999Cargo Group Europe operates 12 hubs worldwide. The Netherlands is our main European hub, Curaçao our Caribbean hub and Miami our USA hub. Reach out directly to the hub closest to your shipment.",
    main_label: "Main hubs",
    other_label: "Other hubs",
    view_all: "View all hubs and locations",
  },

  footer_legal: {
    title: "Legal",
    body:
      "All services, quotes and operations are carried out under the applicable FENEX forwarding conditions and written agreements. Rates, surcharges, local fees, import duties and taxes may depend on destination, volume, weight, documents and market conditions.",
    destinations_title: "Destinations",
    services_title: "Services",
    contact_title: "Contact",
  },
};

export const staticNl = {
  about: {
    seo_title: "Over 5999Cargo — Cargo with a smile sinds 2014",
    seo_description:
      "Maak kennis met 5999Cargo Group Europe — familiebedrijf en expediteur voor verzending van Nederland naar Curaçao, Aruba, Bonaire en het Caribisch gebied sinds 2014. Meertalig team, complete service.",
    seo_keywords: "over 5999Cargo, expediteur Rotterdam Caribisch gebied, Nederlands logistiek bedrijf, familie expediteur",
    eyebrow: "/ Over ons",
    h1_a: "Wij verbinden Nederland met de eilanden —",
    h1_b: "zending voor zending.",
    story_eyebrow: "/ Ons verhaal",
    story_title_a: "Verworteld in Rotterdam.",
    story_title_b: "Verbonden met Curaçao.",
    story_p1:
      "5999Cargo Group Europe is in 2014 opgericht door een Nederlands-Curaçaose familie die het zat was om vrienden en familie te zien betalen voor trage en onbetrouwbare verzending tussen beide landen.",
    story_p2:
      "Wat begon als één gedeelde container die elke twee weken vanuit Rotterdam vertrok, is uitgegroeid tot een full-service expediteur met 1.200+ zendingen per jaar — lucht, zee, verhuizingen en Shop-Drop-Ship voor honderden kleine bedrijven die het Caribisch gebied bedienen.",
    story_p3:
      "We zitten nog steeds in ons originele depot aan de Steenhouwerstraat. Nog steeds een familiebedrijf. Nog steeds op voornaambasis met onze klanten — die meestal begonnen met één doos en nu maandelijks verzenden.",
    stats: [
      { v: "12", l: "Jaar ervaring" },
      { v: "1.200+", l: "Zendingen per jaar" },
      { v: "8", l: "Caribische bestemmingen" },
      { v: "98%", l: "Op tijd geleverd" },
    ],
    values_eyebrow: "/ Onze waarden",
    values_title: "Wat krijg je als je met ons verzendt",
    values: [
      { title: "Rotterdamse wortels", desc: "Familiebedrijf gevestigd aan de Steenhouwerstraat sinds 2014." },
      { title: "Caribische focus", desc: "We verzenden niet overal naartoe — wel naar Curaçao, Aruba, Bonaire en omliggende eilanden. We kennen de routes door en door." },
      { title: "Meertalig team", desc: "Nederlands, Engels, Papiamento, Spaans. We spreken de taal aan beide kanten van de Atlantische Oceaan." },
      { title: "Compliant & verzekerd", desc: "Volledig erkend expediteur, ingeschreven bij de Kamer van Koophandel." },
    ],
  },

  contact: {
    seo_title: "Contact met 5999Cargo Nederland — Offerte & Klantenservice",
    seo_description:
      "Neem contact op met 5999Cargo Nederland voor pakketten, luchtvracht, zeevracht, pickup, tracking en offerte-aanvragen. WhatsApp, e-mail of telefoon — reactie binnen 1 werkuur.",
    seo_keywords: "contact 5999Cargo, verzending Rotterdam contact, vracht Curaçao offerte, klantenservice cargo",
    eyebrow: "/ Contact",
    h1_a: "Praat met een echt mens.",
    h1_b: "Binnen 1 uur.",
    intro:
      "WhatsApp is de snelste manier om ons te bereiken. Of stuur een bericht — we reageren binnen één werkuur tijdens NL-kantooruren (ma–vr 09:00–18:00 CET).",
    card_whatsapp_label: "WhatsApp (snelst)",
    card_email_label: "E-mail",
    card_phone_label: "Telefoon",
    card_hours_label: "Openingstijden",
    card_hours_value_line1: "Ma–Vr 09–18",
    card_hours_value_line2: "Za 10–14",
    card_hours_value_zone: "(CET)",
    tab_quote: "Offerte aanvragen",
    tab_message: "Bericht sturen",
    msg_title: "Bericht sturen",
    msg_name: "Naam",
    msg_email: "E-mail",
    msg_phone: "Telefoon",
    msg_subject: "Onderwerp",
    msg_message: "Bericht",
    msg_submit: "Bericht versturen →",
    msg_sending: "Verzenden...",
    msg_required_error: "Vul alle verplichte velden in.",
    msg_send_success: "Bericht verzonden! We reageren binnen 1 werkuur.",
    msg_send_error: "Verzenden mislukt. Probeer WhatsApp.",
    visit_title: "Bezoek ons",
    company_name: "5999Cargo Group Europe",
    dropoff_title: "Brengen welkom",
    dropoff_desc:
      "Breng je dozen naar ons depot ma–vr 09:00–17:00. Gratis parkeren op locatie. Neem het ontvangstadres mee en wij regelen de rest.",
  },

  webshop: {
    seo_title: "Webshop — Verzenddozen, Ophalen & Betaallinks | 5999Cargo",
    seo_description:
      "Bestel verzenddozen, plan ophalen in Nederland en betaal voor lopende zendingen. Veilige Stripe-checkout.",
    seo_keywords: "verzenddozen Nederland, ophalen Rotterdam, online zending betalen, Stripe checkout vracht",
    eyebrow: "/ Webshop",
    h1: "Dozen, ophaalservice & betalingen.",
    sub:
      "Alles wat je nodig hebt om je pakket te versturen — van stevige dozen tot ophalen op afspraak en veilige online betaling van lopende zendingen.",
    filter_all: "Alles",
    filter_boxes: "Verzenddozen",
    filter_services: "Ophaalservice",
    filter_payment: "Zending betalen",
    add_to_cart: "In winkelmand",
    added_toast: "toegevoegd aan winkelmand",
    cart_empty: "Je winkelmand is leeg. Voeg dozen of services toe om te beginnen.",
    cart_title: "Je winkelmand",
    cart_subtotal: "Subtotaal",
    cart_vat_note: "BTW wordt bij checkout berekend.",
    checkout_email_placeholder: "E-mail voor bon",
    checkout_name_placeholder: "Volledige naam (optioneel)",
    checkout_button: "Veilig afrekenen →",
    checkout_redirecting: "Doorverwijzen...",
    checkout_powered_by: "Mogelijk gemaakt door Stripe",
    checkout_email_required: "Vul je e-mail in voor de orderbon.",
    cart_empty_error: "Winkelmand is leeg.",
    checkout_error: "Afrekenen mislukt. Probeer opnieuw.",
    cta_quote_title: "Liever een offerte dan dozen kopen?",
    cta_quote_sub: "Heb je een complexe zending? We geven binnen 1 werkuur een offerte op maat.",
    cta_quote_label: "Offerte aanvragen",
  },

  payment: {
    seo_title: "Betalingsstatus | 5999Cargo",
    seo_description: "Je betalingsstatus bij 5999Cargo.",
    checking_title: "Betaling bevestigen...",
    checking_sub: "Dit duurt meestal een paar seconden.",
    paid_title: "Betaling ontvangen. Bedankt!",
    paid_sub:
      "We hebben je bon per e-mail verstuurd. Ons team neemt snel contact op met de vervolgstappen voor je zending.",
    back_home: "Terug naar home",
    continue_shopping: "Verder winkelen",
    expired_title: "Betaalsessie verlopen",
    error_title: "Betaling kon niet bevestigd worden",
    missing_sub: "Geen betaalsessie gevonden in de URL.",
    error_sub:
      "Als je de betaling hebt voltooid, ontvang je een e-mailbevestiging. Neem contact op bij twijfels.",
    back_webshop: "Terug naar webshop",
    contact_us: "Neem contact op",
  },

  blog: {
    list_seo_title: "Verzending & Logistiek Blog — Curaçao, Caribisch gebied & Nederland | 5999Cargo",
    list_seo_description:
      "Gidsen, kosten en tips voor het verzenden van pakketten, vracht en verhuizingen tussen Nederland en het Caribisch gebied.",
    list_seo_keywords: "verzendblog, Curaçao verzendgids, vracht tips Nederland, verhuizen Caribisch blog",
    eyebrow: "/ Blog",
    h1: "Verzending & logistiek inzichten.",
    sub:
      "Gidsen, echte kostenoverzichten en douane-tips — geschreven door het team dat elke week verzendt naar het Caribisch gebied.",
    read_article: "Lees artikel",
    not_found: "Artikel niet gevonden",
    back_to_blog: "Terug naar blog",
    all_articles: "Alle artikelen",
    cta_title: "Klaar om te verzenden?",
    cta_sub: "Vraag een offerte in minder dan 60 seconden — of app ons via WhatsApp.",
  },

  not_found: {
    eyebrow: "/ 404",
    h1: "Pagina niet gevonden",
    desc: "De pagina die je zoekt bestaat niet of is verplaatst.",
    back_home: "Terug naar home",
  },

  testimonials_data: [
    {
      name: "Maria S.",
      role: "Verhuisd Rotterdam → Willemstad",
      text: "5999Cargo regelde onze complete verhuizing met zorg. Dozen kwamen intact aan in 14 dagen, exact zoals geoffreerd. Het ophaalteam in Rotterdam was op tijd en professioneel.",
    },
    {
      name: "Kevin D.",
      role: "E-commerce verkoper",
      text: "Ik verstuur 30+ orders per week naar Curaçao. Hun Shop, Drop & Ship halveert mijn fulfillmentkosten t.o.v. PostNL. Tracking is betrouwbaar en douane gaat snel.",
    },
    {
      name: "Anouk P.",
      role: "Pakketten naar familie",
      text: "Een doos van 50 kg naar mijn moeder in Otrobanda gestuurd. Opgehaald uit mijn flat in Den Haag, 11 dagen later bij haar bezorgd. Communicatie via WhatsApp was uitstekend.",
    },
  ],

  process_eyebrow: "/ Proces",

  hubs: {
    seo_title: "Hubs & Locaties | 5999Cargo Group Europe",
    seo_description:
      "12 strategische hubs in Europa, het Caribisch gebied en Amerika — Rotterdam, Curaçao, Miami, Aruba, Bonaire, St. Maarten, Suriname, Dominicaanse Republiek, Venezuela, Colombia, Jamaica, Guyana.",
    seo_keywords:
      "5999Cargo hubs, vracht locaties Caribisch gebied, Rotterdam Curaçao Miami kantoren, internationaal cargo netwerk",
    eyebrow: "/ Hubs & Locaties",
    h1: "Eén netwerk. Twaalf hubs. Deur-tot-deur cargo.",
    intro:
      "We beheren onze eigen fysieke hubs in Europa, het Caribisch gebied en Amerika — zodat jouw lading door ons eigen team wordt behandeld, van ophaal tot eindbezorging. Neem contact op met de hub het dichtst bij jou.",
    featured_title: "Hoofdhubs",
    other_title: "Regionale hubs",
    contact_hub: "Neem contact op met deze hub",
    note_title: "Belangrijke operationele opmerking",
    note_body:
      "Let op: elke lokale hub kan eigen procedures, openingstijden, importregels, handlingkosten en bestemmingskosten hanteren. Voor zendingen die vanuit Nederland vertrekken, verzorgt 5999Cargo Group Europe de Nederlandse intake, registratie, documentcontrole en exportverwerking. Voor lokale levering, invoerrechten of bestemmingskosten neemt u contact op met de betreffende lokale hub.",
    cta_title: "Klaar om te verzenden? Bereik direct de juiste hub.",
    cta_sub: "Vertel ons herkomst + bestemming en we koppelen je aan de hub die jouw route verzorgt.",
    cta_primary: "Vraag offerte aan",
  },

  home_faq: {
    title: "Veelgestelde vragen over cargo naar Curaçao en de Caribbean",
    items: [
      {
        q: "Kan ik een pakket naar Curaçao sturen via 5999Cargo?",
        a: "Ja. U verstuurt via 5999Cargo pakketten, dozen, koffers, pallets, voertuigen en persoonlijke goederen vanuit Nederland naar Curaçao, Aruba, Bonaire, Sint Maarten en Suriname. Wij adviseren luchtvracht voor snelle of kleine zendingen en zeevracht voor grotere volumes — vul direct online uw paklijst of boekingsformulier in.",
      },
      {
        q: "Wat is goedkoper: luchtvracht of zeevracht?",
        a: "Zeevracht is meestal voordeliger voor grotere volumes (dozen, pallets, meubels, verhuisgoederen, voertuigen). Luchtvracht is sneller en geschikt voor kleinere of urgente zendingen. Gebruik onze CBM-calculator of volumemeter voor een eerste indicatie en vraag daarna online een offerte aan.",
      },
      {
        q: "Kan 5999Cargo mijn zending ophalen in Nederland?",
        a: "Ja. Onze Pickup & Delivery service haalt zendingen op aan huis, op kantoor, bij opslag of bij uw leverancier in heel Nederland. Bereken indicatief uw kosten via de pickup-calculator: lokaal (≤ 25 km vanaf Rotterdam) of landelijk met km-vergoeding.",
      },
      {
        q: "Welke documenten heb ik nodig voor een zending?",
        a: "Voor internationale verzending heeft u een duidelijke paklijst, factuur of waardeverklaring nodig. 5999Cargo werkt met documentcontrole vóór vertrek — zonder volledige documenten en betaling vertrekt uw zending niet. Vul uw paklijst online in via /paklijst en upload of stuur uw factuur mee.",
      },
      {
        q: "Wat zijn Dangerous Goods en verboden goederen?",
        a: "Bepaalde goederen mogen niet (zonder voorafgaande toestemming) vervoerd worden — bijvoorbeeld spuitbussen, batterijen, parfum, brandbare vloeistoffen, magneten, wapens, drugs en levende dieren. Bekijk de volledige lijst en categorieën onder /documenten. Iedere paklijst en boeking vereist een akkoord op de Dangerous Goods verklaring.",
      },
      {
        q: "Kan ik online bestellen en laten bezorgen bij 5999Cargo?",
        a: "Ja. Met Shop, Drop & Ship laat u online aankopen uit Europa afleveren op ons depot in Nederland. Wij ontvangen, registreren en verzenden uw pakket door naar uw eindbestemming. Maak gratis een Mijn 5999Cargo-account aan om uw zendingen te volgen.",
      },
      {
        q: "Verzenden jullie ook voor bedrijven en webshops?",
        a: "Ja. 5999Cargo ondersteunt ondernemers, webshops en leveranciers met luchtvracht, zeevracht, pallets, voorraadzendingen, terugkerende cargo en logistieke afhandeling naar het Caribisch gebied. Vraag offerte aan voor structurele zendingen of word agent in uw regio.",
      },
      {
        q: "Hoe betaal ik mijn zending?",
        a: "Veilig online via Stripe op onze pagina /online-betalen. Belangrijk: geen betaling betekent geen verzending — wij vertrekken pas als documenten én betaling compleet zijn. Zo voorkomen we vertraging in de haven of bij de douane.",
      },
      {
        q: "Zijn lokale invoerrechten en heffingen inbegrepen?",
        a: "Nee, lokale invoerrechten, belastingen en afhandelingskosten op bestemming zijn meestal niet inbegrepen, tenzij schriftelijk anders is overeengekomen. Deze kosten worden bepaald door de lokale autoriteiten of afhandelaars op het eiland.",
      },
      {
        q: "Naar welke bestemmingen verzendt 5999Cargo?",
        a: "Naast Curaçao verzendt 5999Cargo naar onder andere Aruba, Bonaire, Sint Maarten, Suriname, Miami, Colombia, Venezuela, Dominicaanse Republiek, Jamaica en Guyana via ons partnernetwerk.",
      },
    ],
  },

  banners: [
    {
      title: "Van Nederland naar Curaçao — online geregeld",
      sub: "Vraag offerte aan, vul direct uw paklijst in of plan een pickup. Met Mijn 5999Cargo, online betalen en duidelijke documentcontrole houdt u zelf het overzicht.",
      cta: "Vraag offerte aan",
      href: "/contact?get-quote=1",
    },
    {
      title: "Online besteld in Europa? Laat het via 5999Cargo doorsturen",
      sub: "Shop, Drop & Ship: levering op ons depot in Nederland en daarna doorzending naar Curaçao, Aruba of de hele Caribbean. Particulier én zakelijk.",
      cta: "Ontdek Shop-Drop-Ship",
      href: "/shop-drop-ship",
    },
    {
      title: "Zakelijke cargo en terugkerende zendingen",
      sub: "Voor webshops, ondernemers en leveranciers die structureel verzenden naar Curaçao, Bonaire, Aruba, Sint Maarten of Suriname. Vaste contactpersoon, online tools en heldere documentcontrole.",
      cta: "Spreek een specialist",
      href: "/contact",
    },
    {
      title: "Grotere zending? Kies zeevracht",
      sub: "Voordelig verzenden per doos, pallet, voertuig of m³. Ideaal voor verhuizingen, voorraad en handelsgoederen. Bereken vooraf uw volume met de CBM-calculator.",
      cta: "Zeevracht opties",
      href: "/sea-freight",
    },
  ],

  contact_hubs: {
    eyebrow: "/ Ons hub-netwerk",
    title: "Internationaal bereik dat u kunt vertrouwen",
    sub:
      "5999Cargo Group Europe heeft 12 hubs wereldwijd. Nederland is onze belangrijkste Europese hub, Curaçao onze Caribbean hub en Miami onze USA hub. Neem direct contact op met de hub het dichtst bij uw zending.",
    main_label: "Hoofdhubs",
    other_label: "Overige hubs",
    view_all: "Bekijk alle hubs en locaties",
  },

  footer_legal: {
    title: "Juridisch",
    body:
      "Alle diensten, offertes en werkzaamheden worden uitgevoerd volgens de toepasselijke FENEX expeditievoorwaarden en schriftelijke afspraken. Tarieven, toeslagen, lokale kosten, invoerrechten en belastingen kunnen afhankelijk zijn van bestemming, volume, gewicht, documenten en marktomstandigheden.",
    destinations_title: "Bestemmingen",
    services_title: "Diensten",
    contact_title: "Contact",
  },
};
